import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, catchError, forkJoin, map, of } from 'rxjs';
import { Cliente } from 'src/app/core/models/cliente.model';
import { Medico } from 'src/app/core/models/medico.model';
import { Loja } from 'src/app/core/models/loja.model';
import { Produto } from 'src/app/core/models/produto.model';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { NovoPedidoOlho } from './components/novo-pedido-olho/novo-pedido-olho.component';
import { OrdemDeServicoComponent } from './components/ordem-de-servico/ordem-de-servico.component';
import { PedidoVendaComponent } from './components/pedido-venda/pedido-venda.component';
import { NovoPedidoAnexoRequest, NovoPedidoProdutoRequest, NovoPedidoReceitaRequest, NovoPedidoRequest, NovoValorRequest } from 'src/app/core/models/request/novo-pedido.request.model';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProdutoResponse } from 'src/app/core/models/response/produto-response.model';
import { NovoPedidoArmacao } from 'src/app/core/models/novo-pedido-armacao.model';
import { ClienteResponse } from 'src/app/core/models/response/cliente-response.model';
import { LojaResponse } from 'src/app/core/models/response/loja-response.model';
import { ConfirmationService } from 'primeng/api';
import * as moment from 'moment';
import {jsPDF} from 'jspdf';
import { Router } from '@angular/router';
import { Profissao, ProfissoesResponse } from 'src/app/core/models/response/profissoes-response.model';
import { TipoCliente, TiposClienteResponse } from 'src/app/core/models/response/tiposclientes-response.model';
import { TipoMarketing, TiposMarketingResponse } from 'src/app/core/models/response/tipos-marketing-response.model';
import { Genero, GenerosResponse } from 'src/app/core/models/response/generos-response.model';
import { ClienteCamposConfiguracao, ClienteCamposConfiguracaoResponse } from 'src/app/core/models/response/cliente-campos-configuracao-response.model';
import { Cidade, CidadesResponse } from 'src/app/core/models/response/cidades-response.model';
import { EnderecoResponse } from 'src/app/core/models/response/endereco-response.model';
import { TableSelectColumn } from 'src/app/shared/components/table-select/table-select.component';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ANEXO_QUANTIDADE_MAXIMA,
  ANEXO_TAMANHO_MAXIMO_BYTES,
  formatarTamanhoArquivo,
  validarExtensaoAnexo,
  validarTamanhoAnexo
} from 'src/app/core/utils/anexo-validacao';

@Component({
  selector: 'app-novo-pedido',
  templateUrl: './novo-pedido.component.html',
  styleUrls: ['./novo-pedido.component.scss']
})

export class NovoPedidoComponent implements OnInit {
  @ViewChild('ordemServicoComponent') ordemServicoComponent?: OrdemDeServicoComponent;
  @ViewChild('pedidoVendaComponent') pedidoVendaComponent?: PedidoVendaComponent;

  novoPedido: NovoPedidoRequest;
  busyCombos: boolean = false;
  busyComboProduto: boolean = false;
  carregadoComboProduto: boolean = false;
  comboOutrosServicos: Produto[] = [];
  produtosAdicionados: Produto[] = [];
  confirmBtnNaoVisible: boolean = false;
  modalCadastrarPedido: boolean = false;
  modalCadastrarCliente: boolean = false;
  pedidoCadastrado?: number;
  textoCadastrarNovoPedido: string;
  id?: string;
  lojaIdOriginal?: any;
  pedido_lab?: string;
  os_numero_readonly: boolean = false;

  opcaoPedidoSelecionado: string = 'pedido_lab';
  tituloPedidoSelecionado: string = 'Pedido Ordem de Serviço (OS)';

  maxDate: Date = new Date();

  private lblSalvandoCliente = 'Estamos salvando seu cliente ...';
  private lblSalvandoPedido = 'Estamos salvando seu pedido ...';
  private lblPedidoSalvo = 'Pedido cadastrado com sucesso';
  private lblPedidoAlterado = 'Pedido alterado com sucesso';
  private lblErroSalvarPedido = 'Não foi possível enviar seu pedido';
  lblModalSalvarPedido = this.lblSalvandoPedido;
  lblModalSalvarCliente = this.lblSalvandoCliente;


  public listagemTipoMontagem = [
    {id: 1, tipo:'ARO FECHADO'},
    {id: 2, tipo:'MEIO ARO (FIO DE NYLON)'},
    {id: 3, tipo:'TRÊS PEÇAS (BALGRIFF)'},
    {id: 4, tipo:'ESPORTIVAS (CURVADAS)'}
  ];

  public listagemPessoaPessoa = [
    { value: 'F', label: 'PESSOA FÍSICA' },
    { value: 'J', label: 'PESSOA JURÍDICA' }
  ];

  listagemGeneroPessoa: Genero[] = [];
  listagemProfissoes: Profissao[] = [];
  listagemTiposCliente: TipoCliente[] = [];
  listagemMarketing: TipoMarketing[] = [];
  marketingSelecionado: TipoMarketing | null = null;
  listagemCidades: Cidade[] = [];
  clienteCamposConfiguracao: ClienteCamposConfiguracao | undefined;

  date: Date;
  enderecoClienteLoading = false;
  dadosCliente = {
    id: null,
    pessoa: "F",
    genero: null,
    nome_completo: null,
    cpf: null,
    data_nascimento: null,
    celular: null,
    profissao: null,
    tipo_cliente: null,
    tem_filhos: false,
    nome_social: null,
    apelido: null,
    endereco: {
      cep: null,
      logradouro: null,
      numero: null,
      complemento: null,
      bairro: null,
      cod_cidade: null,
      estado: null
    },
    razao_social: null,
    nome_fantasia: null,
    cnpj: null,
    optante_simples_nacional: true,
    email: ""
  }
  resetDadosClientes;

  // Forms
  dadosForm = {
    numeroOS: null as any,
    paciente: null as Cliente | null | undefined,
    medico: null as Medico | null | undefined,
    opcaoOlhoSelecionado: 'ambos',
    olhoDireito: {} as NovoPedidoOlho,
    olhoEsquerdo: {} as NovoPedidoOlho,
    armacao: {} as NovoPedidoArmacao,
    servicosAdicionados: [] as Produto[],
    observacao: '',
    anexos: [] as NovoPedidoAnexoRequest[],
    DtReceita: null as any,
    DtPrevisaoEntrega: null as any,
    oldNumeroOS: null as any
  };

  pedidoAprovado: boolean = false;
  loadingSave: boolean = false;
  loadingCliente: boolean = false;
  pdfLiberado: boolean = false;

  anexosExistentes: any[] = [];

  constructor(
    private service: WeblabService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.resetDadosClientes = JSON.parse(JSON.stringify(this.dadosCliente));
  }

  async ngOnInit() {
    this.route.url.subscribe((event) => {
      if (event[0].path === 'pedido-venda') {
        this.opcaoPedidoSelecionado = 'pedido_venda';
        this.tituloPedidoSelecionado = 'Pedido Venda'
      }
    });

    this.id = (this.route.snapshot.paramMap.get('id') || "").toString().trim() || undefined;
    this.pedido_lab = (this.route.snapshot.paramMap.get('loja_id') || "").toString().trim() || undefined;

    await this.carregarLojasClientes();
    if (this.id) {
      if (this.pedido_lab) {
        this.laboratorioSelecionado = (this.lojas || []).find((l: any) => l.id == this.pedido_lab) || undefined;
      }
      
      await this.loadData(this.id);
    }
    await this.carregaCombos(true);

    this.date = new Date(moment().subtract(0, 'days').format());
  }

  lojas: Array<Loja>;
  laboratorioSelecionado: Loja | undefined;

  clientes: Array<Cliente>;
  lojaSelecionada: Cliente | undefined;
  loadingClientes: boolean = false;

  colunasClientes: TableSelectColumn[] = [
    { field: 'nome_completo', header: 'Nome Completo' },
    { field: 'cpf', header: 'CPF/CNPJ', format: (v) => {
      if (!v) return '';
      const s = String(v).replace(/\D/g, '');
      if (s.length <= 11)
        return `${s.substr(0,3)}.${s.substr(3,3)}.${s.substr(6,3)}-${s.substr(9)}`;
      return `${s.substr(0,2)}.${s.substr(2,3)}.${s.substr(5,3)}/${s.substr(8,4)}-${s.substr(12)}`;
    }},
  ];

  produtos: Array<Produto>;
  produtosLentes: Array<Produto>;

  async carregarLojasClientes() {
    this.busyCombos = true;
    const dadosLojas = await new Promise((resolve, reject) => this.service.buscarLojas().subscribe({ next: resolve, error: reject }));

    let lojas = (dadosLojas as LojaResponse)?.dados;

    this.lojas = lojas?.sort((a, b) => {
      const nameA = a.razao_social.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      const nameB = b.razao_social.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      
      if (nameA < nameB) {
        return -1;
      }

      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    this.service.clientes = [];
    this.service.lojas = this.lojas;
  }

  async buscarCliente(cod_cliente: string) {
    const self = this;
    let clientes: Cliente[] = [];
    try {
      const dadosClientes = await new Promise((resolve, reject) => self.service.buscarClienteCod(cod_cliente).subscribe({ next: resolve, error: reject }));
      clientes = (dadosClientes as ClienteResponse)?.dados;
    }
    catch(e) {
      console.error(e);
    }

    return clientes[0] || null;
  }

  async buscarMedico(cod_medico: any) {
    let medicos: Medico[] = [];
    try {
      const dadosMedicos = await new Promise((resolve, reject) => this.service.buscarMedicoCod(cod_medico).subscribe({ next: resolve, error: reject }));
      medicos = (dadosMedicos as any)?.dados || [];
    }
    catch(e) {
      console.error(e);
    }

    return medicos.find(m => m.id == cod_medico) || null;
  }

  async buscarClientes(event: any) {
    const self = this;
    const search = event?.query || "";
    let clientes: Cliente[] = [];
    self.loadingClientes = true;
    try {
      const dadosClientes = await new Promise((resolve, reject) => self.service.buscarClientes(search).subscribe({ next: resolve, error: reject }));
      clientes = (dadosClientes as ClienteResponse)?.dados;
    }
    catch(e) {
      console.error(e);
    }
    finally {
      self.loadingClientes = false;
    }
    
    self.clientes = clientes?.sort((a, b) => {
      const nameA = a.nome_completo.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      const nameB = b.nome_completo.replace(/\s/g, "").toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
  }

  async buscarCidadeIBGE(ibge: string) {
    const self = this;
    let cidades: Cidade[] = [];
    try {
      const dadosCidades = await new Promise((resolve, reject) => self.service.cidades(ibge, undefined, 1, 1).subscribe({ next: resolve, error: reject }));
      cidades = (dadosCidades as CidadesResponse)?.dados || [];
    }
    catch(e) {
      console.error(e);
    }
    
    return cidades[0];
  }

  async buscarCidades(event: any) {
    const self = this;
    const search = event?.query || "";
    if (!search || search.length < 3) {
      self.listagemCidades = [];
      return;
    }

    let cidades: Cidade[] = [];
    try {
      const dadosCidades = await new Promise((resolve, reject) => self.service.cidades(undefined, search).subscribe({ next: resolve, error: reject }));
      cidades = (dadosCidades as CidadesResponse)?.dados || [];
    }
    catch(e: any) {
      console.error(e);
      let codigo = e?.error?.erro?.codigo;
      if (codigo == "BUSCA_INVALIDA") {
        self.listagemCidades = [];
        return;
      }
      let message =e?.error?.erro?.mensagem || e.message;
      this.toastr.error("Erro ao buscar cidades. "+message);
    }
    self.listagemCidades = cidades
  }

  async buscarEndereco() {
    const cep = (this.dadosCliente.endereco.cep || "").toString().replace(/[^\d]+/g, '');
    if (cep.length < 8) {
      return;
    }

    const self = this;
    try {
      this.enderecoClienteLoading = true;
      const endereco: EnderecoResponse = await new Promise((resolve, reject) => self.service.buscarEndereco(cep).subscribe({ next: resolve, error: reject }));
      if (endereco.sucesso && endereco.dados?.bairro) {
        this.dadosCliente.endereco.bairro = endereco.dados.bairro.substring(0, 30) as any;
        this.dadosCliente.endereco.logradouro = endereco.dados.logradouro as any;

        if (endereco.dados.codigo_ibge) {
          const cidade = await this.buscarCidadeIBGE(endereco.dados.codigo_ibge);
          this.dadosCliente.endereco.cod_cidade = cidade as any;
          this.listagemCidades = [cidade];
        }
      }
    }
    catch(e) {
      console.error(e);
    }
    finally {
      this.enderecoClienteLoading = false;
    }
  }

  async carregaCombos(init = false) {
    const dadosGeneros: GenerosResponse = await new Promise((resolve, reject) => this.service.generos().subscribe({ next: resolve, error: reject }));
    const dadosProfissoes: ProfissoesResponse = await new Promise((resolve, reject) => this.service.profissoes().subscribe({ next: resolve, error: reject }));
    const dadosTiposCliente: TiposClienteResponse = await new Promise((resolve, reject) => this.service.tiposCliente().subscribe({ next: resolve, error: reject }));
    const dadosClientesCamposConfiguracao: ClienteCamposConfiguracaoResponse = await new Promise((resolve, reject) => this.service.clientesCamposConfiguracao().subscribe({ next: resolve, error: reject }));
    const dadosTiposMarketing: TiposMarketingResponse = await new Promise((resolve, reject) => this.service.tiposMarketing().subscribe({ next: resolve, error: reject }));

    this.listagemProfissoes = dadosProfissoes?.dados || [];
    this.listagemTiposCliente = dadosTiposCliente?.dados || [];
    this.listagemGeneroPessoa = dadosGeneros?.dados || [];
    this.listagemMarketing = dadosTiposMarketing?.dados || [];
    this.clienteCamposConfiguracao = dadosClientesCamposConfiguracao?.dados;
    
    if (this.clienteCamposConfiguracao && Array.isArray(this.clienteCamposConfiguracao.campos)) {
      let dict: any = {
        "CLICNPJ": "cnpj",
        "CLICPF": "cpf",
        "CLINASCIMENTO": "data_nascimento",
        "CLICELULAR": "celular",
        "CLINOMEFANTASIA": "nome_fantasia"
      };

      this.clienteCamposConfiguracao.campo = {};
      for (const key in this.dadosCliente) {
        let exibir = "S";
        const parametro_exibir_key = `exibir_${key}`;
        if ((this.clienteCamposConfiguracao as any).parametros[parametro_exibir_key] == "N") {
          exibir = "N";
        }

        this.clienteCamposConfiguracao.campo[key] = {
          nome: key,
          exibir,
          obrigatorio: "N"
        } as any;
      }

      for (const campo of this.clienteCamposConfiguracao.campos) {
        let key = (campo.nome || "").toString().trim().toUpperCase();
        if (dict[key]) {
          key = dict[key];
        }
        else {
          key = key.replace(/^CLI/gi, "").toLowerCase();
        }

        let exibir = "S";
        const parametro_exibir_key = `exibir_${key}`;
        if ((this.clienteCamposConfiguracao as any).parametros[parametro_exibir_key] == "N") {
          exibir = "N";
        }

        this.clienteCamposConfiguracao.campo[key] = {
          ...campo,
          exibir
        } as any;
      }

      // Garante que a obrigatoriedade destes campos siga sempre o parâmetro
      // correspondente (o mesmo utilizado pelo ÓTICOM desktop), independente
      // do que a lista "campos" tenha retornado, evitando divergência entre
      // web e desktop.
      const dictParametroObrigatorio: { [key: string]: string } = {
        cpf: 'obrigar_cpf',
        data_nascimento: 'obrigar_data_nascimento',
        celular: 'obrigar_celular'
      };

      for (const key in dictParametroObrigatorio) {
        const parametroKey = dictParametroObrigatorio[key];
        const campo = this.clienteCamposConfiguracao.campo[key];
        if (campo && (this.clienteCamposConfiguracao as any).parametros) {
          campo.obrigatorio = (this.clienteCamposConfiguracao as any).parametros[parametroKey] === 'S' ? 'S' : 'N';
        }
      }
    }

    if (this.listagemTiposCliente.length > 0) {
      this.dadosCliente.tipo_cliente = this.listagemTiposCliente[0].id as any;
    }
    
    if (this.service.lojas?.length > 0 && this.service.clientes?.length > 0) {
      console.log('combos ja carregados');

      this.lojas = this.service.lojas;
      this.clientes = this.service.clientes;
      
      await this.campoPreenchido(init);
      this.busyCombos = false;
      return;
    }
    
    await this.campoPreenchido(init);
    this.busyCombos = false;
  }

  async campoPreenchido(init = false) {
    if (!this.id) {
      if(this.lojas?.length == 1) {
        this.laboratorioSelecionado = this.lojas[0];
      }
  
      if(this.clientes?.length == 1) {
        this.lojaSelecionada = this.clientes[0];
      }
    }
  }

  handleRequest() {
    return function (observable: Observable<any>) {
      return observable.pipe(
        map((result) => {
          return result;
        }),
        catchError((err) => {
          return of(null);
        })
      );
    };
  }

  valorTotal() {
    return this.produtosAdicionados
      .map(item => (item.vlr_liquido_produto ?? item.preco_venda ?? 0) * item.quantidadeAdd)
      .reduce((prev, curr) => prev + curr, 0);
  }

  descontoTotal() {
    return 0;
    // return this.produtosAdicionados
    //   .map(item => (item.vlr_venda_tratado - item.vlr_liquido_produto) * item.quantidadeAdd)
    //   .reduce((prev, curr) => prev + curr, 0);
  }
  
  confirmCadastrarPedido() {
    this.confirmBtnNaoVisible = true;

    this.confirmationService.confirm({
      header: this.id ? 'Alterar pedido' : 'Cadastrar novo pedido',
      message: this.id ? 'Realmente deseja alterar este pedido?' : 'Realmente deseja cadastrar este novo pedido?',
      // icon: 'pi pi-question',
      accept: () => {
        this.salvarPedido();
      },
      reject: () => {
        this.confirmBtnNaoVisible = false;
      }
    });
  }

  recuperarValor(subtotal: number, quant: number, porcentagem: number): number {
    const fator = 1 - (porcentagem / 100);
    return subtotal / (quant * fator);
  }

  calcularValor(valor: number, quant: number, porcentagem: number): number {
    const multiplicacao = (valor || 0) * (quant || 0);
    const desconto = ((porcentagem || 0) / 100) * multiplicacao;
    return multiplicacao - desconto;
  }

  get lojaBloqueada(): boolean {
    return !!this.lojaIdOriginal || this.carregadoComboProduto || this.produtosAdicionados.length > 0 || !!this.dadosForm.numeroOS;
  }

  get tituloLojaBloqueada(): string {
    if (this.lojaIdOriginal) {
      return 'Não é permitido alterar a loja de uma OS já enviada.';
    }

    return this.produtosAdicionados.length > 0 || this.dadosForm.numeroOS ? 'Não é permitido alterar a loja após informar a OS ou incluir itens.' : '';
  }

  validarForm() {
    if (!this.lojaSelecionada) {
      throw Error("Por favor, selecione um cliente.");
    }

    if (this.id && this.lojaIdOriginal && this.laboratorioSelecionado?.id != this.lojaIdOriginal) {
      throw Error("Não é permitido alterar a loja de uma OS já enviada.");
    }

    if (!this.dadosForm.DtReceita && (this.dadosForm.olhoDireito.olhoLongeEsferico || this.dadosForm.olhoDireito.olhoLongeCilindrico || this.dadosForm.olhoEsquerdo.olhoLongeEsferico || this.dadosForm.olhoEsquerdo.olhoLongeCilindrico)) {
      throw Error("Por favor, selecione a data da receita.");
    }

    if (!this.dadosForm.DtPrevisaoEntrega) {
      throw Error("Por favor, selecione a data de previsão de entrega.");
    }

    this.validarAnexos();
  }

  private validarAnexos() {
    const totalAnexos = (this.anexosExistentes?.length || 0) + (this.dadosForm.anexos?.length || 0);
    if (totalAnexos > ANEXO_QUANTIDADE_MAXIMA) {
      throw Error(`É permitido no máximo ${ANEXO_QUANTIDADE_MAXIMA} arquivos anexados por pedido.`);
    }

    for (const anexo of (this.dadosForm.anexos || [])) {
      if (!validarExtensaoAnexo(anexo.nome_arquivo)) {
        throw Error(`O arquivo "${anexo.nome_arquivo}" possui um formato não permitido.`);
      }

      const tamanho = anexo.arquivo?.size;
      if (tamanho && !validarTamanhoAnexo(tamanho)) {
        throw Error(`O arquivo "${anexo.nome_arquivo}" (${formatarTamanhoArquivo(tamanho)}) excede o tamanho máximo permitido de ${formatarTamanhoArquivo(ANEXO_TAMANHO_MAXIMO_BYTES)}.`);
      }
    }
  }

  salvarPedido() {
    this.lblModalSalvarPedido = this.lblSalvandoPedido;
    this.loadingSave = true;
    this.modalCadastrarPedido = true;
    this.pedidoCadastrado = undefined;

    try {
      this.validarForm();

      let olhoDireito = this.dadosForm.olhoDireito;
      let olhoEsquerdo = this.dadosForm.olhoEsquerdo;
      let armacao = this.dadosForm.armacao;
      let carrinho: Array<NovoPedidoProdutoRequest> = [];
      let valorL: Array<NovoValorRequest> = [];
      const anexosExistentes: Array<NovoPedidoAnexoRequest> = this.anexosExistentes.map((anexo) => ({
        arquivo: anexo.arquivo,
        tipo_conteudo: anexo.tipo_conteudo,
        nome_arquivo: anexo.nome_arquivo
      }));
      let anexos: Array<NovoPedidoAnexoRequest> = [...anexosExistentes, ...this.dadosForm.anexos];
      
      this.produtosAdicionados.forEach(servico => {
        carrinho.push({
          cod_produto: servico.codigo,
          valor: servico.preco_venda,
          quantidade: servico.quantidadeAdd,
          uso_olho: servico.tipo_prod,
          desc_acresc_porcentagem: servico.desc_acresc_porcentagem,
          subtotal_prod: this.calcularValor(servico.vlr_venda_tratado, servico.quantidadeAdd, servico.desc_acresc_porcentagem),
        })
      });
      
      this.produtosAdicionados.forEach(servico => {
        valorL.push({
          valorLiquidoTotal: servico.preco_venda * servico.quantidadeAdd
        })
      })

      const dataPrevisaoEntrega = this.dadosForm.DtPrevisaoEntrega?.toISOString();

      this.novoPedido = {
        tipo_movimento: "OS",
        loja_id: this.id && this.lojaIdOriginal ? this.lojaIdOriginal : this.laboratorioSelecionado?.id,
        cod_cliente: this.lojaSelecionada?.id,
        cod_paciente: this.dadosForm.paciente?.id,
        nro_os_loja: this.dadosForm.numeroOS as any,
        previsao_entrega: dataPrevisaoEntrega,
        cod_medico: this.dadosForm.medico?.id,
        mk_codigo: this.marketingSelecionado?.mk_codigo,
        carrinho,
        Receita: this.retornaReceita(olhoDireito, olhoEsquerdo, armacao),
        anexos: anexos.map((anexo) => ({
          arquivo: anexo.arquivo,
          tipo_conteudo: anexo.tipo_conteudo,
          nome_arquivo: anexo.nome_arquivo,
          descricao: anexo.descricao
        }))
      }

      if (!this.id) {
        this.service.cadastrarPedido(this.novoPedido).subscribe({
          next: (resp) => {
            this.pedidoCadastrado = resp?.dados?.mov_tipo_nro;
            this.textoCadastrarNovoPedido = ``;
            this.lblModalSalvarPedido = this.id ? this.lblPedidoAlterado : this.lblPedidoSalvo;
            this.pdfLiberado = true;
            this.limpar();
          },
          error: (error) => {
            this.loadingSave = false;
            this.confirmBtnNaoVisible = false;
            this.pdfLiberado = false;

            let msgError = error?.error?.erro?.mensagem || "";
            this.textoCadastrarNovoPedido = `Erro ao cadastrar pedido: ${msgError}`;
          },
          complete: () => {
            this.loadingSave = false;
          }
        })
      }
      else {
        this.service.atualizarPedido(this.id, this.novoPedido).subscribe({
          next: (resp) => {
            this.pedidoCadastrado = resp?.dados?.mov_tipo_nro;
            this.textoCadastrarNovoPedido = ``;
            this.lblModalSalvarPedido = this.id ? this.lblPedidoAlterado : this.lblPedidoSalvo;
            this.pdfLiberado = true;
            this.limpar();
          },
          error: (error) => {
            this.loadingSave = false;
            this.confirmBtnNaoVisible = false;
            this.pdfLiberado = false;

            let msgError = error?.error?.erro?.mensagem || "";
            this.textoCadastrarNovoPedido = `Erro ao atualizar pedido: ${msgError}`;
          },
          complete: () => {
            this.loadingSave = false;
          }
        })
      }
    } catch (e: any) {
      this.pdfLiberado = false;
      this.loadingSave = false;
      this.lblModalSalvarPedido = this.lblErroSalvarPedido;
      this.textoCadastrarNovoPedido = `Erro ao cadastrar pedido: ${e.message}`;
      console.error(e);
    }
  }

  private retornaReceita(olhoDireito: NovoPedidoOlho, olhoEsquerdo: NovoPedidoOlho, armacao: any): NovoPedidoReceitaRequest {
    if (this.opcaoPedidoSelecionado !== 'pedido_lab') return {} as any;

    const dataReceita = this.dadosForm.DtReceita?.toISOString();

    return {
      tipo_lente: "LT",
      data_receita: dataReceita,
      longe_esferico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeEsferico),
      longe_esferico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeEsferico),
      longe_cilindrico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeCilindrico),
      longe_cilindrico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeCilindrico),
      longe_eixo_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeEixo),
      longe_eixo_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeEixo),
      longe_dnp_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoLongeDNP),
      longe_dnp_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoLongeDNP),
      adicao_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoAdicao),
      adicao_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoAdicao),
      perto_esferico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoEsferico),
      perto_esferico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoEsferico),
      perto_cilindrico_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoCilindrico),
      perto_cilindrico_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoCilindrico),
      perto_eixo_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoEixo),
      perto_eixo_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoEixo),
      perto_dnp_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoPertoDNP),
      perto_dnp_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPertoDNP),
      altura_pupila_olho_direito: this.formatDecimalToStringApi(olhoDireito?.olhoAlturaPupila),
      altura_pupila_olho_esquerdo: this.formatDecimalToStringApi(olhoEsquerdo?.olhoAlturaPupila),
      prisma_valor_horizontal_od: this.formatDecimalToStringApi(olhoDireito?.olhoPrismaHorizontalValor),
      prisma_base_horizontal_od: olhoDireito?.olhoPrismaHorizontalBase?.nome ?? '',
      prisma_valor_vertical_od: this.formatDecimalToStringApi(olhoDireito?.olhoPrismaVerticalValor),
      prisma_base_vertical_od: olhoDireito?.olhoPrismaVerticalBase?.nome ?? '',
      prisma_valor_horizontal_oe: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPrismaHorizontalValor),
      prisma_base_horizontal_oe: olhoEsquerdo?.olhoPrismaHorizontalBase?.nome ?? '',
      prisma_valor_vertical_oe: this.formatDecimalToStringApi(olhoEsquerdo?.olhoPrismaVerticalValor),
      prisma_base_vertical_oe: olhoEsquerdo?.olhoPrismaVerticalBase?.nome ?? '',
      distancia_pupilar: this.formatDecimalToStringApi(armacao.armacaoDistPupilar),
      ponte: this.formatDecimalToStringApi(armacao.armacaoPonte),
      aro: this.formatDecimalToStringApi(armacao.armacaoAro),
      diagonal_maior: this.formatDecimalToStringApi(armacao.armacaoDiagMaior),
      diametro_apurado: this.formatDecimalToStringApi(armacao.armacaoDiamApurado),
      mov_alt_vertical: this.formatDecimalToStringApi(armacao.armacaoAltVertical),
      instrucoes_especiais: '',
      previsao_entrega: '',
      observacao: this.dadosForm.observacao,
      datanasc_paciente: '',
      parentesco_paciente: '',
      tipo_montagem: armacao.tipoMontagem?.id,
      data_nasc_paciente: ''
    };
  }

  public async limpar(preservePartialData: boolean = false) {
    this.os_numero_readonly = false;
    this.confirmBtnNaoVisible = false;
    this.busyCombos = false;
    this.busyComboProduto = false;
    this.carregadoComboProduto = false;
    this.loadingSave = false;
    if (!preservePartialData) {
      this.lojaIdOriginal = undefined;
      this.lojaSelecionada = undefined;
      this.laboratorioSelecionado = undefined;
      this.marketingSelecionado = null;
    }

    this.produtosAdicionados = [];
    this.anexosExistentes = [];
    this.ordemServicoComponent?.limparAnexos();
    this.pedidoVendaComponent?.limparAnexos();
    this.dadosForm = {
      numeroOS: null,
      paciente: null,
      medico: null,
      opcaoOlhoSelecionado: 'ambos',
      olhoDireito: {} as NovoPedidoOlho,
      olhoEsquerdo: {} as NovoPedidoOlho,
      armacao: {} as NovoPedidoArmacao,
      servicosAdicionados: [] as Produto[],
      anexos: [],
      DtReceita: null as any,
      DtPrevisaoEntrega: null as any,
      oldNumeroOS: null as any,
      observacao: ""
    };

    await this.campoPreenchido();
  }

  deletarServico(prouduto: any, index: any) {
    this.produtosAdicionados.splice(index, 1);
  }

  async fecharModalRespostaCadastrarPedido() {
    if (this.pedidoCadastrado) {
      if (!this.id) {
        this.limpar();
      }
      else {
        this.router.navigate(["/oticomweb/pedidos"]);
        return;
      }
    }

    this.campoPreenchido();

  }

  async fecharModalRespostaCadastrarCliente() {
    
  }

  pedidoValido() {
    return !this.loadingSave &&
      !!this.lojaSelecionada &&
      !!this.laboratorioSelecionado &&
      this.produtosAdicionados.length > 0;
  }

  formatDecimalToStringApi(value?: number | string): any {
    if (value === undefined || value === null || value === '') return '';

    if (typeof value === 'number') {
      return value.toLocaleString('pt-BR', { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    return value;
  }

  solicitarPDF(opcaoPedidoSelecionado: string) {
    this.service.buscarClienteCod(this.novoPedido.cod_cliente).subscribe({
      next: (cliente: ClienteResponse) => {
        const clienteSelecionado = cliente.dados.filter(x => x.id === this.novoPedido.cod_cliente);  
        this.imprimirPdf(opcaoPedidoSelecionado, clienteSelecionado[0]);            
      },
    });
  }

  // imprimirPdf(opcaoPedidoSelecionado: string, cliente: any) {

  //   let logo = this.logoLaboratorio();

  //   const margins = { top: 30, bottom: 30, left: 10, right: 10 };

  //   const doc = new jsPDF();
  //   doc.setFont('Helvetica');
  //   doc.setFontSize(18);
  //   doc.addImage(logo, 160, 10, 40, 20);
  //   doc.text('Pedido OticomLab', 10, 20);

  //   if(opcaoPedidoSelecionado === 'pedido_lab') {

  //     doc.setFontSize(12);
  //     doc.text(`Laboratório: ${this.laboratorioSelecionado?.razao_social}`, 10, 40);
  //     doc.text(`Pedido: ${this.pedidoCadastrado}`, 165, 40);
  //     doc.text(`Ótica: ${this.lojaSelecionada?.nome}`, 10, 50);
  //     doc.text(`OS: ${this.novoPedido?.nro_os_loja}`, 10, 60);
  //     doc.text(`Paciente: ${this.novoPedido?.Receita?.paciente}`, 40, 60);

  //     let dataFormatada = this.formatDate(this.novoPedido?.Receita?.data_receita);
  //     doc.text(`Data: ${dataFormatada}`, 165, 60);
  //   }
    
  //   if(opcaoPedidoSelecionado === 'pedido_venda') {

  //     doc.setFontSize(12);
  //     doc.text(`Laboratório: ${this.laboratorioSelecionado?.razao_social}`, 10, 40);
  //     doc.text(`Pedido: ${this.pedidoCadastrado}`, 165, 40);
  //     doc.text(`Ótica: ${this.lojaSelecionada?.nome}`, 10, 50);
  //     doc.text(`Data: ${this.novoPedido?.Receita?.data_receita}`, 165, 60);    
  //   }

  //   doc.text(`Itens`, 10, 80);
  //   doc.text(`Produtos`, 10, 90);
  //   doc.text(`Qtde`, 118, 90);
  //   doc.text(`Valor`, 135, 90);
  //   doc.text(`Desconto`, 158, 90);
  //   doc.text(`Subtotal`, 180, 90);

  //   for (let i = 0; i < this.produtosAdicionados.length; i++) {
  //     let item = i * 10;
  //     let linha = 100 + item;
      
  //     doc.text(`${this.produtosAdicionados[i].descricao}`, 10, linha, {maxWidth: 100});
  //     doc.text(`${this.produtosAdicionados[i].quantidadeAdd}`, 120, linha + 2);

  //     let formattedValue = this.produtosAdicionados[i].vlr_venda_tratado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //     doc.text(`R$ ${formattedValue}`, 135, linha + 2);

  //     doc.text(`${this.produtosAdicionados[i].desc_acresc_porcentagem ?? 0 }%`, 165, linha + 2);

  //     let sub = this.produtosAdicionados[i].vlr_liquido_produto * this.produtosAdicionados[i].quantidadeAdd
  //     let subformattedValue = sub.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //     doc.text(`R$ ${subformattedValue}`, 180, linha + 2);    
  //   }

  //   let item = (this.produtosAdicionados.length * 10) + 105;

  //   doc.text(`Qtde de itens ${this.produtosAdicionados.length}`, 135, item);
  //   doc.text(`Desconto total ${this.descontoTotal()}`, 135, item + 10);
    
  //   let formattedValorT = this.valorTotal().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //   doc.text(`Valor total R$ ${formattedValorT}`, 135, item + 20);

  //   doc.text(`Observações`, 10, item + 40);
  //   doc.text(`${this.novoPedido.Receita?.observacao}`, 10, item + 50); 

  //   doc.save('pedido_otc_lab.pdf');
  // }

  imprimirPdf(opcaoPedidoSelecionado: string, cliente: any) {
    const doc =  new jsPDF();
    // 1° quadro
    doc.roundedRect(10, 10, 190, 30, 2, 2); // 1° retangulo
    // let logo = this.logoLaboratorio();
    // doc.addImage(logo,'JPEG', 12.5, 12.5, 35, 25); // imagem (imageData, formato, x, y, width, height)

    const cam1linha1: number = 17;
    const cam1linha2: number = 26;
    const cam1linha3: number = 36;
    const cam2linha1: number = 52;
    const cam2linha2: number = 57;
    const cam2linha3: number = 62;
    const cam3linha1: number = 78;
    const cam3linha2: number = 84;
    const camInt1titulo: number = 91;
    const camInt1linha1: number = 98;
    const camInt1linha2: number = 104;
    const camInt1linha3: number = 110;
    const camInt2titulo: number = 118;
    const camInt2linha1: number = 125;
    const camInt2linha2: number = 130;
    const tituloSpec: number = 175;
    const tituloSpec2: number = 75;
    const desc1Spec: number = 182;
    const desc1Spec2: number = 82;
    const desc2Spec: number = 189;
    const desc3Spec: number = 196;
    const desc4Spec: number = 203;
    // 1° linha
    doc.setFont('Helvetica');
    doc.setFontSize(8);    
    doc.text(`${this.laboratorioSelecionado?.nome_fantasia}`, 50, cam1linha1);
    doc.setFont('Helvetica','','bold');
    doc.setFontSize(8);
    doc.text('Pedido Lab:', 142, cam1linha1);
    doc.setTextColor(135,17,17);
    const nPedido = this.pedidoCadastrado ?? "-";
    doc.text(nPedido.toString(), 160, cam1linha1, {maxWidth:40});
    // doc.text(this.novoPedido?.nro_os_loja, 160, cam1linha1, {maxWidth:40});

    // 2° linha
    doc.setFontSize(8);
    doc.setTextColor(0,0,0);
    
    doc.setFont('Helvetica','','bold');
    doc.text('Data do período:', 50, cam1linha2);
    doc.setFont('Helvetica','','normal');
    let dataFormatada = this.formatDate(this.date.toString());

    doc.text(dataFormatada ? dataFormatada : '-', 75, cam1linha2);
    // doc.text('-', 75, cam1linha2);
    doc.setFont('Helvetica','','bold');
    doc.text('Previsão entrega:', 142, cam1linha2);
    doc.setFont('Helvetica','','normal');
    doc.text(this.novoPedido?.Receita?.previsao_entrega ? this.novoPedido?.Receita?.previsao_entrega : '-', 168, cam1linha2);

    // 3° linha
    doc.setFont('Helvetica','','bold');
    doc.setTextColor(255,9,9);
    doc.text(`VENDA - 01 DIGITAÇÃO`, 50, cam1linha3);
    // doc.text(`VENDA -`, 50, cam1linha3);
    doc.setTextColor(0,0,0);
    doc.text('Entrega efetiva:', 142, cam1linha3);
    doc.setFont('Helvetica','','normal');
    doc.text(this.novoPedido?.Receita?.previsao_entrega ? this.novoPedido?.Receita?.previsao_entrega : '-', 168, cam1linha3);

    // 2° quadro
    doc.roundedRect(10, 45, 190, 20, 2, 2); // 2° retangulo
    doc.setFillColor(255,255,255); // cor retangulo branco
    doc.rect(15, 42.5, 30, 5,'F'); // retangulo branco
    doc.setFont('Helvetica','','bold');
    doc.setTextColor(135,17,17);
    doc.text('Dados da Loja', 18, 46);
    // 1° linha
    doc.setTextColor(0,0,0);
    doc.text('Cliente', 15, cam2linha1);
    doc.setFont('Helvetica','','normal');
    // doc.text(this.novoPedido?.Receita?.paciente ? this.novoPedido?.Receita?.paciente : '-', 30, cam2linha1);
    doc.setFont('Helvetica','','bold');
    doc.text('Telefone', 128, cam2linha1);
    doc.text('Celular', 155, cam2linha1);
    doc.text('OS', 187, cam2linha1);
    // 2° linha
    doc.setFont('Helvetica','','normal');
    // doc.text(cliente.cod_cliente ? cliente.cod_cliente.toString() : '-', 18, cam2linha2);
    doc.text(cliente.nome_fantasia_social ? cliente.nome_fantasia_social : '-', 18, cam2linha2);
    doc.text(cliente.telefone ? cliente.telefone : '-', 128, cam2linha2);
    doc.text(cliente.celular ? cliente.celular : '-', 155, cam2linha2);
    doc.setFont('Helvetica','','bold');
    doc.text('Cliente', 185, cam2linha2);
    // 3° linha
    doc.text('Endereço:', 15, cam2linha3);
    doc.setFont('Helvetica','','normal');
    const endereco = cliente.endereco ? cliente.endereco : '-';
    const numero = cliente.numero ? cliente.numero : '-';
    const complemento = cliente.complemento ? cliente.complemento : '-';
    const bairro = cliente.bairro ? cliente.bairro : '-';
    const cidade = cliente.cidade ? cliente.cidade : '-';
    const estado = cliente.estado ? cliente.estado : '-';
    const enderecoCompleto = `${endereco}, ${numero}, ${complemento}, ${bairro}, ${cidade} / ${estado}`;
    doc.text(`${enderecoCompleto}`, 30, cam2linha3);
    doc.text(this.novoPedido?.nro_os_loja ? this.novoPedido?.nro_os_loja : '-', 185, cam2linha3);

    if(opcaoPedidoSelecionado === 'pedido_lab') {
      // 3° quadro
      doc.roundedRect(10, 70, 190, 71, 2, 2); // 3° retangulo
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(15, 67.5, 30, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(135,17,17);
      doc.text('Dados da receita', 18, 71);
      // 1° linha
      doc.setTextColor(0,0,0);
      doc.setFont('Helvetica','','bold');
      doc.text('Paciente:', 15, cam3linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.dadosForm?.paciente?.nome_completo ? this.dadosForm.paciente.nome_completo : '-', 30, cam3linha1);
      // 2° linha
      doc.setFont('Helvetica','','bold');
      doc.text('Data da receita:', 157, cam3linha2);
      doc.setFont('Helvetica','','normal');
      let dataFormatadaReceita = this.formatDate(this.novoPedido?.Receita?.data_receita);
      doc.text(dataFormatadaReceita ? dataFormatadaReceita : '-', 180, cam3linha2);
      // 1° quadro interno
      doc.roundedRect(15, 90, 180, 22, 2, 2); // retangulo interno
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(20, 88, 10, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(25,9,175);
      doc.text('Longe', 21, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(57, 88, 9, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Perto', 58, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(92, 88, 19, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Dist. Pupilar', 93, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(115, 88, 16, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Alt. Pupila', 116, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(135, 88, 26, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Prisma horizontal', 136, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(165, 88, 25, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Prisma vertical', 168, camInt1titulo);
      // 1° linha
      doc.setTextColor(0,0,0);
      doc.setFontSize(6); 
      doc.text('Esf.', 28, camInt1linha1);
      doc.text('Cil.', 36, camInt1linha1);
      doc.text('Eixo', 42, camInt1linha1);
      doc.text('DNP', 49, camInt1linha1);
      doc.text('Adição', 56, camInt1linha1);
      doc.text('Esf.', 64, camInt1linha1);
      doc.text('Cil.', 71, camInt1linha1);
      doc.text('Eixo', 78, camInt1linha1);
      doc.text('DNP', 84, camInt1linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.distancia_pupilar ? this.novoPedido?.Receita?.distancia_pupilar.toString() : '-', 100, camInt1linha1);
      doc.setFont('Helvetica','','bold');
      doc.text('Valor', 138, camInt1linha1);
      doc.text('Base', 150, camInt1linha1);
      doc.text('Valor', 168, camInt1linha1);
      doc.text('Base', 180, camInt1linha1);

      doc.line(25,100,190,100);
      doc.line(25,106,190,106);
      // doc.line(25,94,25,112);
      doc.line(54.5,94,54.5,112);
      doc.line(90,94,90,112);
      doc.line(113,94,113,112);
      doc.line(133,94,133,112);
      doc.line(163,94,163,112);
      // 2° linha
      doc.setFontSize(8); 
      doc.text('OD', 20, camInt1linha2);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(this.novoPedido?.Receita?.longe_esferico_olho_direito ? this.novoPedido?.Receita?.longe_esferico_olho_direito.toString() : '-', 28, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.longe_cilindrico_olho_direito ? this.novoPedido?.Receita?.longe_cilindrico_olho_direito.toString() : '-', 35, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.longe_eixo_olho_direito ? this.novoPedido?.Receita?.longe_eixo_olho_direito.toString() : '-', 42, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.longe_dnp_olho_direito ? this.novoPedido?.Receita?.longe_dnp_olho_direito.toString() : '-', 49, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.adicao_olho_direito ? this.novoPedido?.Receita?.adicao_olho_direito.toString() : '-', 56, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_esferico_olho_direito ? this.novoPedido?.Receita?.perto_esferico_olho_direito.toString() : '-', 64, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_cilindrico_olho_direito ? this.novoPedido?.Receita?.perto_cilindrico_olho_direito.toString() : '-', 71, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_eixo_olho_direito ? this.novoPedido?.Receita?.perto_eixo_olho_direito.toString() : '-', 78, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.perto_dnp_olho_direito ? this.novoPedido?.Receita?.perto_dnp_olho_direito.toString() : '-', 84, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.altura_pupila_olho_direito ? this.novoPedido?.Receita?.altura_pupila_olho_direito.toString() : '-', 122.5, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_valor_horizontal_od ? this.novoPedido?.Receita?.prisma_valor_horizontal_od.toString() : '-', 140, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_base_horizontal_od ? this.novoPedido?.Receita?.prisma_base_horizontal_od.toString() : '-', 150, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_valor_vertical_od ? this.novoPedido?.Receita?.prisma_valor_vertical_od.toString() : '-', 170, camInt1linha2);
      doc.text(this.novoPedido?.Receita?.prisma_base_vertical_od ? this.novoPedido?.Receita?.prisma_base_vertical_od.toString() : '-', 180, camInt1linha2);
      // 3° linha
      doc.setFont('Helvetica','','bold');
      doc.setFontSize(8); 
      doc.text('OE', 20, camInt1linha3);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(this.novoPedido?.Receita?.longe_esferico_olho_esquerdo ? this.novoPedido?.Receita?.longe_esferico_olho_esquerdo.toString() : '-', 28, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.longe_cilindrico_olho_esquerdo ? this.novoPedido?.Receita?.longe_cilindrico_olho_esquerdo.toString() : '-', 35, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.longe_eixo_olho_esquerdo ? this.novoPedido?.Receita?.longe_eixo_olho_esquerdo.toString() : '-', 42, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.longe_dnp_olho_esquerdo ? this.novoPedido?.Receita?.longe_dnp_olho_esquerdo.toString() : '-', 49, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.adicao_olho_esquerdo ? this.novoPedido?.Receita?.adicao_olho_esquerdo.toString() : '-', 56, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_esferico_olho_esquerdo ? this.novoPedido?.Receita?.perto_esferico_olho_esquerdo.toString() : '-', 64, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_cilindrico_olho_esquerdo ? this.novoPedido?.Receita?.perto_cilindrico_olho_esquerdo.toString() : '-', 71, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_eixo_olho_esquerdo ? this.novoPedido?.Receita?.perto_eixo_olho_esquerdo.toString() : '-', 78, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.perto_dnp_olho_esquerdo ? this.novoPedido?.Receita?.perto_dnp_olho_esquerdo.toString() : '-', 84, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.altura_pupila_olho_esquerdo ? this.novoPedido?.Receita?.altura_pupila_olho_esquerdo.toString() : '-', 122.5, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_valor_horizontal_oe ? this.novoPedido?.Receita?.prisma_valor_horizontal_oe.toString() : '-', 140, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_base_horizontal_oe ? this.novoPedido?.Receita?.prisma_base_horizontal_oe.toString() : '-', 150, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_valor_vertical_oe ? this.novoPedido?.Receita?.prisma_valor_vertical_oe.toString() : '-', 170, camInt1linha3);
      doc.text(this.novoPedido?.Receita?.prisma_base_vertical_oe ? this.novoPedido?.Receita?.prisma_base_vertical_oe.toString() : '-', 180, camInt1linha3);
      // 2° quadro interno
      doc.roundedRect(15, 117, 180, 18, 2, 2); // retangulo interno
      doc.setFontSize(8); 
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(20, 115, 27, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(25,9,175);
      doc.text('Dados da armação', 21, camInt2titulo);
      doc.setTextColor(0,0,0);
      doc.text('Ponte', 22, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.ponte ? this.novoPedido?.Receita?.ponte.toString() : '-', 24, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Aro', 42, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.aro ? this.novoPedido?.Receita?.aro.toString() : '-', 43, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Alt. Vertical', 59, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.mov_alt_vertical ? this.novoPedido?.Receita?.mov_alt_vertical.toString() : '-', 65, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Diag.Maior', 88, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.diagonal_maior ? this.novoPedido?.Receita?.diagonal_maior.toString() : '-', 94, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Diâm. Apurado', 120, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido?.Receita?.diametro_apurado ? this.novoPedido?.Receita?.diametro_apurado.toString() : '-', 127, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Tipo de montagem', 158, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(this.novoPedido?.Receita?.tipo_montagem ? this.tipoMontagem(this.novoPedido?.Receita?.tipo_montagem) : '-', 159, camInt2linha2);

      doc.setFont('Helvetica','','bold');
      doc.setFontSize(8);
      doc.text('Observações', 10, 148);
      // doc.text('Observações', 110, 148);
      doc.setFont('Helvetica','','normal');
      doc.text(this.novoPedido.Receita?.observacao ? this.novoPedido.Receita?.observacao : '-', 10, 155, {maxWidth:90});
      // doc.text(item.Receita?.observacao ? item.Receita?.observacao : '-', 110, 155, {maxWidth:90});

      doc.setFont('Helvetica','','bold');
      // doc.text('Esp', 10, tituloSpec);
      doc.text('Olho', 10, tituloSpec);
      doc.text('Item', 20, tituloSpec);
      doc.text('UN', 155, tituloSpec);
      doc.text('Qtde', 170, tituloSpec);
      doc.text('Subtotal', 185, tituloSpec);
      doc.line(10,177,200,177); // linha
  
      let qttd = 0;
      for (let i = 0; i < this.novoPedido?.carrinho.length; i++) {
        let item = i * 7;
        let linha = desc1Spec + item;
        doc.setFont('Helvetica','','normal');
        // doc.text(this.novoPedido?.carrinho[i].uso_olho ? 'L' : 'M', 10, linha);
        doc.text(this.novoPedido?.carrinho[i].uso_olho ? this.novoPedido?.carrinho[i].uso_olho : '-', 10, linha);
        doc.text(this.produtosAdicionados[i]?.descricao ? this.produtosAdicionados[i]?.descricao : '-', 22, linha);
        doc.text('PC', 155, linha);
        doc.text(this.novoPedido?.carrinho[i].quantidade ? this.novoPedido?.carrinho[i].quantidade.toFixed(2) : '-', 170, linha);
        let formattedSubValor = this.novoPedido?.carrinho[i].subtotal_prod.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        doc.text(`R$ ${formattedSubValor}`, 185, linha); 
        
        doc.line(10,184,200,184); // linha
        doc.line(10,191,200,191); // linha
        qttd += this.novoPedido?.carrinho[i].quantidade;    
  
      }
      let totalLinha = (this.novoPedido?.carrinho.length * 10) + 179;
      // doc.line(10,198,200,198); // linha
      doc.setFont('Helvetica','','bold');
      doc.text('Totais:', 130, totalLinha);
      doc.text(qttd.toFixed(2).toString(), 170, totalLinha);
      let formattedValorT = this.valorTotal().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      doc.text(`R$ ${formattedValorT}`, 185, totalLinha);

    } 
    if(opcaoPedidoSelecionado === 'pedido_venda') {
      doc.setFont('Helvetica','','bold');
      // doc.text('Esp', 12, tituloSpec2);
      doc.text('Olho', 12, tituloSpec2);
      doc.text('Item', 22, tituloSpec2);
      doc.text('UN', 157, tituloSpec2);
      doc.text('Qtde', 172, tituloSpec2);
      doc.text('Subtotal', 187, tituloSpec2);
      doc.line(12,77,200,77); // linha
      let qttd2 = 0;
      for (let i = 0; i < this.novoPedido?.carrinho.length; i++) {
        let item = i * 7;
        let linha = desc1Spec2 + item;
        doc.setFont('Helvetica','','normal');
        // doc.text('L', 12, linha);
        doc.text(this.novoPedido?.carrinho[i].uso_olho ? this.novoPedido?.carrinho[i].uso_olho : '-', 12, linha);
        doc.text(this.produtosAdicionados[i].descricao ? this.produtosAdicionados[i].descricao : '-', 24, linha);
        doc.text('PC', 157, linha);
        doc.text(this.novoPedido?.carrinho[i].quantidade ? this.novoPedido?.carrinho[i].quantidade.toFixed(2) : '-', 172, linha);
        let formattedSubValor = this.novoPedido?.carrinho[i].subtotal_prod.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        doc.text(`R$ ${formattedSubValor}`, 187, linha); 
        
        doc.line(12,84,200,84); // linha
        // doc.line(12,91,200,91); // linha

        if(i >= 2 ) {
          doc.line(12,84 + 7,200,84 + 7); // linha
          doc.line(12,91 + 7,200,91 + 7); // linha
        }        
        qttd2 += this.novoPedido?.carrinho[i].quantidade;    
  
      }
      let totalLinha = (this.novoPedido?.carrinho.length * 7) + desc1Spec2;
      // doc.line(12,98,200,98); // linha
      doc.setFont('Helvetica','','bold');
      doc.text('Totais:', 132, totalLinha);
      doc.text(qttd2.toFixed(2).toString(), 172, totalLinha);
      let formattedValorT = this.valorTotal().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      doc.text(`R$ ${formattedValorT}`, 187, totalLinha);
    }

    let nomeArquivo = `PEDIDO-${this.pedidoCadastrado }`
    doc.save(`${nomeArquivo}.pdf`);
  }
  
  formatDate(dateString: string | undefined): string {
    if (!dateString) {
      return '';
    }
  
    const formattedDateString = dateString.replace(/_/g, '-');
    const date = new Date(formattedDateString);
  
    if (isNaN(date.getTime())) {
      return 'Data inválida';
    }
  
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
  
    return `${day}/${month}/${year}`;
  }

  logoLaboratorio() {
    let storageValue = localStorage.getItem('weblab_logo_lab'); 
    let logo = 'data:image/jpg;base64,' + storageValue;
    return logo
  }

  tipoMontagem(tipo_id: any) {
    let montagem = this.listagemTipoMontagem.filter(x => x.id.toString().includes(tipo_id.toString()));
    return montagem[0].tipo;
  }

  async loadData(id: string, data: any = undefined) {
    if (!data) {
      data = await new Promise((resolve, reject) => this.service.pedidoId(id, this.laboratorioSelecionado?.id).subscribe({ next: resolve, error: reject }));
    }
    else {
      data.loja_id = this.lojaSelecionada?.id;
    }

    data = Array.isArray(data?.dados) ? data.dados[0] : null;
    if (data.cod_cliente && (!this.lojaSelecionada || this.lojaSelecionada.id != data.cod_cliente)) {
      const cliente = await this.buscarCliente(data.cod_cliente);
      this.lojaSelecionada = cliente;
      this.clientes = cliente ? [cliente] : [];
    }

    if (data.cod_medico) {
      this.dadosForm.medico = await this.buscarMedico(data.cod_medico);
    }

    this.marketingSelecionado = data?.MKCodigo ? { mk_codigo: data.MKCodigo, mk_descricao: data.MkDescricao } as TipoMarketing : null;

    this.pedidoAprovado = (data?.mov_baixado || "").trim().toUpperCase() == "S";

    this.laboratorioSelecionado = (this.lojas || []).find((l) => data?.loja_id && l.id == data.loja_id) || undefined;
    this.lojaIdOriginal = this.laboratorioSelecionado?.id;
    this.lojaSelecionada = (this.clientes || []).find((c) => data?.cod_cliente && c.id == data.cod_cliente) || undefined;

    this.produtosAdicionados = (data?.carrinho || []).map((item: any) => {
      const subtotal_prod = parseFloat(item.subtotal_prod || 0);
      const vlr_venda_tratado = this.recuperarValor(subtotal_prod, item.quantidade, item.desc_acresc_porcentagem);

      return {
        codigo: item.cod_produto,
        descricao: item.produto_descricao,
        quantidadeAdd: item.quantidade,
        vlr_venda_tratado,
        desc_acresc_porcentagem: item.desc_acresc_porcentagem,
        vlr_liquido_produto: item.quantidade > 0 ? (item.subtotal_prod / item.quantidade) : 0,
        tipo_prod: item.uso_olho || ""
      }
    });

    const olhoDireito = this.produtosAdicionados.find(p => p.tipo_prod.toString().trim().toUpperCase() == "D") || undefined;
    const olhoEsquerdo = this.produtosAdicionados.find(p => p.tipo_prod.toString().trim().toUpperCase() == "E") || undefined;

    const formatOlhoPrismaHorizontalBase = (valor: any) => {
      if (typeof valor == "string") {
        if (/Nasal/i.test(valor.trim())) {
          return {
            id: 1,
            nome: "Nasal"
          };
        }
        else if (/Temporal/i.test(valor.trim())) {
          return {
            id: 2,
            nome: "Temporal"
          };
        }
      }

      return null;
    };

    const formatOlhoPrismaVerticalBase = (valor: any) => {
      if (typeof valor == "string") {
        if (/Inferior/i.test(valor.trim())) {
          return {
            id: 3,
            nome: "Inferior"
          };
        }
        else if (/Superior/i.test(valor.trim())) {
          return {
            id: 4,
            nome: "Superior"
          };
        }
      }

      return null;
    };

    this.dadosForm.opcaoOlhoSelecionado = "ambos";

    if (olhoDireito && !olhoEsquerdo) {
      this.dadosForm.opcaoOlhoSelecionado = "olho_direito";
    }
    else if (!olhoDireito && olhoEsquerdo) {
      this.dadosForm.opcaoOlhoSelecionado = "olho_esquerdo";
    }

    this.dadosForm.numeroOS = data?.nro_os_loja ?? null;
    this.dadosForm.oldNumeroOS = this.dadosForm.numeroOS;
    this.dadosForm.paciente = data?.Receita?.paciente ?? null;
    this.dadosForm.DtReceita = data?.Receita?.data_receita  && moment(data.Receita.data_receita).isValid() ? moment(data.Receita.data_receita).toDate() : null;
    this.dadosForm.DtPrevisaoEntrega = data?.previsao_entrega && moment(data.previsao_entrega).isValid() ? moment(data.previsao_entrega).toDate() : null;
    this.dadosForm.olhoDireito = {
      olhoLongeEsferico: this.formatDecimalToStringApi(data?.Receita?.longe_esferico_olho_direito),
      olhoLongeCilindrico: this.formatDecimalToStringApi(data?.Receita?.longe_cilindrico_olho_direito),
      olhoLongeEixo: this.formatDecimalToStringApi(data?.Receita?.longe_eixo_olho_direito),
      olhoLongeDNP: this.formatDecimalToStringApi(data?.Receita?.longe_dnp_olho_direito),
      olhoAdicao: this.formatDecimalToStringApi(data?.Receita?.adicao_olho_direito),
      olhoPertoEsferico: this.formatDecimalToStringApi(data?.Receita?.perto_esferico_olho_direito),
      olhoPertoCilindrico: this.formatDecimalToStringApi(data?.Receita?.perto_cilindrico_olho_direito),
      olhoPertoEixo: this.formatDecimalToStringApi(data?.Receita?.perto_eixo_olho_direito),
      olhoPertoDNP: this.formatDecimalToStringApi(data?.Receita?.perto_dnp_olho_direito),
      olhoAlturaPupila: this.formatDecimalToStringApi(data?.Receita?.altura_pupila_olho_direito),
      olhoPrismaHorizontalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_horizontal_od),
      olhoPrismaHorizontalBase: formatOlhoPrismaHorizontalBase(data?.Receita?.prisma_base_horizontal_od),
      olhoPrismaVerticalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_vertical_od),
      olhoPrismaVerticalBase: formatOlhoPrismaVerticalBase(data?.Receita?.prisma_base_vertical_od)
    };

    this.dadosForm.olhoEsquerdo = {
      olhoLongeEsferico: this.formatDecimalToStringApi(data?.Receita?.longe_esferico_olho_esquerdo),
      olhoLongeCilindrico: this.formatDecimalToStringApi(data?.Receita?.longe_cilindrico_olho_esquerdo),
      olhoLongeEixo: this.formatDecimalToStringApi(data?.Receita?.longe_eixo_olho_esquerdo),
      olhoLongeDNP: this.formatDecimalToStringApi(data?.Receita?.longe_dnp_olho_esquerdo),
      olhoAdicao: this.formatDecimalToStringApi(data?.Receita?.adicao_olho_esquerdo),
      olhoPertoEsferico: this.formatDecimalToStringApi(data?.Receita?.perto_esferico_olho_esquerdo),
      olhoPertoCilindrico: this.formatDecimalToStringApi(data?.Receita?.perto_cilindrico_olho_esquerdo),
      olhoPertoEixo: this.formatDecimalToStringApi(data?.Receita?.perto_eixo_olho_esquerdo),
      olhoPertoDNP: this.formatDecimalToStringApi(data?.Receita?.perto_dnp_olho_esquerdo),
      olhoAlturaPupila: this.formatDecimalToStringApi(data?.Receita?.altura_pupila_olho_esquerdo),
      olhoPrismaHorizontalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_horizontal_oe),
      olhoPrismaHorizontalBase: formatOlhoPrismaHorizontalBase(data?.Receita?.prisma_base_horizontal_oe),
      olhoPrismaVerticalValor: this.formatDecimalToStringApi(data?.Receita?.prisma_valor_vertical_oe),
      olhoPrismaVerticalBase: formatOlhoPrismaVerticalBase(data?.Receita?.prisma_base_vertical_oe)
    };

    const tiposMontagem: any[] = [
      {
        id: 1,
        nome: 'Aro fechado'
      },
      {
        id: 2,
        nome: 'Meio Aro (Fio de Nylon)'
      },
      {
        id: 3,
        nome: 'Três peças (Balgriff)'
      },
      {
        id: 4,
        nome: 'Esportiva'
      }
    ];

    this.dadosForm.armacao = {
      tipoMontagem: tiposMontagem.find(t => t.id == data?.Receita?.tipo_montagem) || null,
      armacaoPonte: this.formatDecimalToStringApi(data?.Receita?.ponte),
      armacaoAro: this.formatDecimalToStringApi(data?.Receita?.aro),
      armacaoAltVertical: this.formatDecimalToStringApi(data?.Receita?.mov_alt_vertical),
      armacaoDiagMaior: this.formatDecimalToStringApi(data?.Receita?.diagonal_maior),
      armacaoDiamApurado: data?.Receita?.diametro_apurado ?? null,
      armacaoDistPupilar: this.formatDecimalToStringApi(data?.Receita?.distancia_pupilar)
    };

    this.dadosForm.observacao = data?.Receita?.observacao ?? null;

    this.anexosExistentes = (data?.anexos || []).map((anexo: any) => {
      const isImagem = (anexo.tipo_conteudo || '').startsWith('image/');
      const dataUrl = `data:${anexo.tipo_conteudo};base64,${anexo.conteudo}`;

      return {
        nome_arquivo: anexo.nome_arquivo,
        tipo_conteudo: anexo.tipo_conteudo,
        isImagem,
        url: this.sanitizer.bypassSecurityTrustUrl(dataUrl),
        arquivo: this.base64ParaArquivo(anexo.conteudo, anexo.nome_arquivo, anexo.tipo_conteudo)
      };
    });
  }

  private base64ParaArquivo(base64: string, nomeArquivo: string, tipoConteudo: string): File {
    const bytes = atob(base64);
    const array = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
      array[i] = bytes.charCodeAt(i);
    }
    return new File([array], nomeArquivo, { type: tipoConteudo });
  }

  removerAnexoExistente(anexo: any) {
    this.anexosExistentes = this.anexosExistentes.filter(a => a !== anexo);
  }

  validarCliente() {
    if (!this.clienteCamposConfiguracao?.campo) {
      return true;
    }

    for (const key in this.dadosCliente) {
      const campo = this.clienteCamposConfiguracao.campo[key];
      if (campo && campo.obrigatorio == "S" && (!(this.dadosCliente as any)[key] || (this.dadosCliente as any)[key] === "")) {
        if (key == 'cpf' || key == 'cnpj') {
          if ((key == 'cpf' && this.dadosCliente.pessoa == "F") || (key == 'cnpj' && this.dadosCliente.pessoa == "J")) {
            this.toastr.error(`O campo "${campo.rotulo || campo.nome || key}" é obrigatório.`);
            return false;
          }
        }
        else {
          this.toastr.error(`O campo "${campo.rotulo || campo.nome || key}" é obrigatório.`);
          return false;
        }
      }
    }

    const email = (this.dadosCliente?.email || '') as string;
    if (email && email.trim() !== '') {
      if (!email.includes('@')) {
        this.toastr.error('O e-mail informado não é válido. Verifique o formato e tente novamente.');
        return false;
      }
      const partes = email.split('@');
      const beforeAt = partes[0] || '';
      const afterAt = partes[1] || '';
      if (!beforeAt || !afterAt || !afterAt.includes('.')) {
        this.toastr.error('O e-mail informado não é válido. Verifique o formato e tente novamente.');
        return false;
      }
      const afterParts = afterAt.split('.');
      if (afterParts.length < 2 || afterParts[0].length === 0 || afterParts[afterParts.length - 1].length === 0) {
        this.toastr.error('O e-mail informado não é válido. Verifique o formato e tente novamente.');
        return false;
      }
    }

    // Validação específica de cidade (endereço) – exigida ao salvar cadastro de cliente
    const cidadeAtual = this.dadosCliente?.endereco?.cod_cidade;
    if (!cidadeAtual) {
      this.toastr.error('Informe a cidade');
      return false;
    }

    return true;
  }

  async salvarCliente() {
    if (!this.validarCliente()) {
      return;
    }

    this.loadingCliente = true;
    try {
      const data = JSON.parse(JSON.stringify(this.dadosCliente));
      data.tem_filhos = data.tem_filhos ? "S" : "N";
      data.optante_simples_nacional = data.optante_simples_nacional ? "S" : "N";
      data.endereco.cod_cidade = data.endereco.cod_cidade && typeof data.endereco.cod_cidade == "object" ? data.endereco.cod_cidade.id : data.endereco.cod_cidade;
      data.endereco.cep = data.endereco.cep?.replace(/[^\d]+/g, '')?.slice(0, 8);
      data.cpf = data.cpf?.replace(/[^\d]+/g, '') || null;
      data.cnpj = data.cnpj?.replace(/[^\d]+/g, '') || null;
      data.celular = data.celular?.replace(/[^\d]+/g, '') || null;

      if (typeof data.data_nascimento == "string" && /^(\d{2}\/\d{2}\/\d{4})$/.test((data.data_nascimento || "").trim())) {
        data.data_nascimento = moment.utc(data.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD') as any;
      }

      // Campos não obrigatórios e não preenchidos não são enviados. Enviar um
      // valor "null" explícito para um campo opcional em branco pode fazer o
      // backend tentar gravar o parâmetro sem tipo definido (erro de FireDAC).
      if (this.clienteCamposConfiguracao?.campo) {
        for (const key of Object.keys(this.clienteCamposConfiguracao.campo)) {
          const campo = this.clienteCamposConfiguracao.campo[key];
          const valor = (data as any)[key];
          const vazio = valor === null || valor === undefined || valor === '';
          if (campo?.obrigatorio !== 'S' && vazio && key in data) {
            delete (data as any)[key];
          }
        }
      }

      delete data.id;

      let cliente: Cliente | null = null;
      if (!this.dadosCliente.id) {
        data.loja_id = this.laboratorioSelecionado?.id;

        const response: any = await new Promise((resolve, reject) => this.service.cadastrarCliente(data).subscribe({ next: resolve, error: reject }));
        if (response?.dados?.id) {
          cliente = await this.buscarCliente(response.dados.id);
        }
      }
      else {
        const response: any = await new Promise((resolve, reject) => this.service.atualizarCliente(this.dadosCliente.id as any, data).subscribe({ next: resolve, error: reject }));
        if (response?.dados?.id) {
          cliente = await this.buscarCliente(response.dados.id);
        }
      }

      if (cliente) {
        this.clientes = [cliente];
        this.lojaSelecionada = cliente;
      }
      
      this.toastr.success("Cliente salvo com sucesso!");
      this.modalCadastrarCliente = false;
    }
    catch(e: any) {
      console.error(e);
      this.toastr.error(this.obterMensagemErroSalvarCliente(e));
    }
    finally {
      this.loadingCliente = false;
    }
  }

  /**
   * Traduz erros técnicos retornados pela API (ex.: erros de banco de dados
   * do FireDAC/MSSQL, como "Parameter [CLINASCIMENTO] data type is unknown")
   * em mensagens compreensíveis para o usuário final.
   */
  private obterMensagemErroSalvarCliente(e: any): string {
    const mensagemOriginal: string = (e?.error?.erro?.mensagem || e?.message || '').toString();

    const dictColunaCampo: { [coluna: string]: string } = {
      "CLICNPJ": "cnpj",
      "CLICPF": "cpf",
      "CLINASCIMENTO": "data_nascimento",
      "CLICELULAR": "celular",
      "CLINOMEFANTASIA": "nome_fantasia"
    };

    // Anexa a exceção original às mensagens traduzidas, para não mascarar a
    // causa real do erro.
    const detalhe = mensagemOriginal ? ` (Detalhe: ${mensagemOriginal})` : '';

    const matchParametro = mensagemOriginal.match(/Parameter\s*\[([A-Z_]+)\]/i);
    if (matchParametro) {
      const coluna = matchParametro[1].toUpperCase();
      const key = dictColunaCampo[coluna] || coluna.replace(/^CLI/i, '').toLowerCase();
      const campo = this.clienteCamposConfiguracao?.campo?.[key];
      const rotulo = campo?.rotulo || key;
      // Só acusa obrigatoriedade quando a configuração realmente exige o
      // campo; caso contrário a falha é técnica da API, não do usuário.
      if (campo?.obrigatorio === 'S') {
        return `O campo "${rotulo}" é obrigatório. Preencha esta informação e tente salvar novamente.${detalhe}`;
      }
      return `Não foi possível salvar o cliente: o servidor falhou ao gravar o campo "${rotulo}" em branco. Contate o suporte.${detalhe}`;
    }

    if (/data type is unknown|TFDParam|FireDAC/i.test(mensagemOriginal)) {
      return `Não foi possível salvar o cliente. Verifique se todos os campos obrigatórios foram preenchidos corretamente e tente novamente.${detalhe}`;
    }

    return mensagemOriginal ? `Erro ao salvar cliente. ${mensagemOriginal}` : "Erro ao salvar cliente. Tente novamente.";
  }

  novoCliente() {
    this.lblModalSalvarCliente = "Novo cliente";
    this.modalCadastrarCliente = true;
    this.dadosCliente = JSON.parse(JSON.stringify(this.resetDadosClientes));
    if (this.listagemTiposCliente.length > 0) {
      this.dadosCliente.tipo_cliente = this.listagemTiposCliente[0].id as any;
    }
  }

  async alterarCliente(cod_cliente: any) {
    this.lblModalSalvarCliente = "Alterar cliente";
    this.modalCadastrarCliente = true;
    try {
      this.loadingCliente = true;
      const cliente = await this.buscarCliente(cod_cliente);
      if (!cliente) {
        throw new Error("Cliente não encontrado");
      }

      this.dadosCliente.id = cliente.id as any;
      this.dadosCliente.apelido = cliente.apelido as any;
      this.dadosCliente.celular = cliente.celular as any;
      this.dadosCliente.cnpj = cliente.cnpj as any;
      this.dadosCliente.cpf = cliente.cpf as any;
      this.dadosCliente.data_nascimento = cliente.data_nascimento && moment.utc(cliente.data_nascimento).isValid() ? moment.utc(cliente.data_nascimento).format('DD/MM/YYYY') as any : null;
      this.dadosCliente.endereco.bairro = cliente.endereco?.bairro as any;
      this.dadosCliente.endereco.cep = cliente.endereco?.cep as any;
      this.dadosCliente.endereco.complemento = cliente.endereco?.complemento as any;
      this.dadosCliente.endereco.logradouro = cliente.endereco?.logradouro as any;
      this.dadosCliente.endereco.numero = cliente.endereco?.numero as any;
      this.dadosCliente.endereco.cod_cidade = cliente.endereco?.cod_cidade as any;
      this.dadosCliente.genero = cliente.genero as any;
      this.dadosCliente.nome_completo = cliente.nome_completo as any;
      this.dadosCliente.nome_fantasia = cliente.nome_fantasia as any;
      this.dadosCliente.nome_social = cliente.nome_social as any;
      this.dadosCliente.email = (cliente as any).email ?? "";
      this.dadosCliente.optante_simples_nacional = cliente.optante_simples_nacional == "S";
      this.dadosCliente.pessoa = cliente.pessoa;
      this.dadosCliente.profissao = cliente.profissao as any;
      this.dadosCliente.razao_social = cliente.razao_social as any;
      this.dadosCliente.tem_filhos = cliente.tem_filhos == "S";
      this.dadosCliente.tipo_cliente = cliente.tipo_cliente as any;
    }
    catch(error) {
      console.error(error);
      this.toastr.error("Erro ao carregar dados do cliente.");
      this.modalCadastrarCliente = false;
    }
    finally {
      this.loadingCliente = false;
    }
  }

  async checarOSNumero(numero: string) {
    if (numero === '' || numero === null || numero === undefined) {
      await this.limpar(true)
    }
    else {
      try {
        const pedido = await new Promise((resolve, reject) => this.service.pedidoId(numero, this.laboratorioSelecionado?.id).subscribe({ next: resolve, error: reject }));
        if (!pedido) {
          this.toastr.info("Número da OS disponível para uso.", "Informação");
          this.os_numero_readonly = true;
          return;
        }

        const self = this;
        this.confirmBtnNaoVisible = true;

        this.confirmationService.confirm({
          header: 'Número de OS',
          message: 'Número de OS já cadastrada, deseja carregá-la?',
          rejectVisible: true,
          rejectLabel: "Não",
          // icon: 'pi pi-question',
          accept: () => {
            this.id = numero;
            self.loadData(numero, pedido);
            this.os_numero_readonly = true;
          },
          reject: () => {
            this.id = null as any;
            self.dadosForm.numeroOS = null;
            this.confirmBtnNaoVisible = false;
            this.os_numero_readonly = false;
          }
        });
      }
      catch(error: any) {
        const status = error.status;
        const message = error.error?.erro?.mensagem || error.message;
        if (status == 404) {
          this.toastr.info("Número da OS disponível para uso.", "Informação");
        }
        else {
          this.toastr.error(message, 'Erro');
        }
      }
    }
  }

  maskDate(e: any) {
    let input = e?.target;
    if (!input) return;

    let value = (input.value || "").toString();

    if (/^(\w{2})(\w{1})$/.test(value)) {
      value = value.replace(/^(\w{2})(\w{1})$/, "$1/$2");
    }
    else if (/(^\w{2}\/\w{2})(\w{1})$/.test(value)) {
      value = value.replace(/(^\w{2}\/\w{2})(\w{1})$/, "$1/$2");
    }

    input.value = value;
  }
}
